import {useMemo} from "react";
import {skipToken} from "@reduxjs/toolkit/query";
import {regionPermissions, regionsSelector, useGetAccessibleRegionsQuery} from "@ots-frontend/ots-data";
import {useAuth} from "../providers/AuthProvider/AuthProvider";

/**
 * The regions the signed-in user can work in, and whether they may switch between them or use the Global view.
 * The server scopes the list, so an empty list means the user has no region access.
 */
export const useAccessibleRegions = () => {
  const {userId, hasAccess} = useAuth();

  const selectRegions = useMemo(() => {
    return regionsSelector()
  }, []);

  const {regions, isLoading} = useGetAccessibleRegionsQuery(userId ? undefined : skipToken, {
    selectFromResult: (result) => ({
      regions: selectRegions(result, {}),
      isLoading: result.isLoading,
    })
  });

  return {
    regions,
    isLoading,
    canSwitchRegion: hasAccess(regionPermissions.switch),
    canAccessGlobal: hasAccess(regionPermissions.globalAccess),
  };
};
